import { render } from "./DataTableActionFields.vue?vue&type=template&id=9451b916"
import script from "./DataTableActionFields.vue?vue&type=script&lang=js"
export * from "./DataTableActionFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__